import xhr from '../utils/xhr';

let api = {
    get:   (filters = { query: null }) => {
        let searchFilter = filters.query !== null && filters.query.length ? `&nameFilter=${encodeURIComponent(filters.query)}` : ""
        return xhr.get({
            url: `/api/categories/?pageNumber=-1&pageSize=-1&sortBy=nameSort&direction=asc${searchFilter}`
        })
    },
    count: (filters = {query: null}) => {
        let searchFilter = filters.query !== null && filters.query.length ? `?nameFilter=${encodeURIComponent(filters.query)}` : ""
        return xhr.get({
            url: `/api/categories/count${searchFilter}`
        });
    }
};

export default api;


// WEBPACK FOOTER //
// ./src/scripts/api/CategoriesAudit.api.js